module.exports = __webpack_public_path__ + "static/shoutcart_about-326fcd3827f067ab5d65d71e43a9eb42.png";